<template>
  <div class="head">
    <p>乾保网</p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() { },
  mounted() { },
  methods: {},
}
</script>

<style lang='less' scoped>
.head {
  position: fixed;
  top: 0;
  z-index: 99999;
  width: 100%;
  height: 80px;
  line-height: 80px;
  background: #1777FF;
  font-weight: bold;
  color: #FFFFFF;
  font-size: 36px;
  text-align: center;
  font-family: Microsoft YaHei UI;
}
</style>